import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appointmentExcelReports, appointmentSales } from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { useState } from 'react';
import { BsDownload } from 'react-icons/bs';
import { Button } from 'react-bootstrap';
import * as XLSX from 'xlsx';


export default function AppointmentReport() {

    const dispatch = useDispatch();
    const reportData = useSelector((state) => state.report)
    console.log('reportData',reportData);
    // const getTodayDate = () => {
    //     const today = new Date();
    //     const year = today.getFullYear();
    //     const month = String(today.getMonth() + 1).padStart(2, '0');
    //     const day = String(today.getDate()).padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    // };
    const [formData, setFormData] = React.useState({
        dateOfAppointment: '',
        status: '',
        search: '',
    })
    const [isExporting, setIsExporting] = useState(false);

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleFormData = (e) => {
        const { name, value } = e.target;
        setFormData((prev => ({
            ...prev,
            [name]: value,
        })))
    }
    const ChangeMainPage = ({ selected }) => {
        setMainPage(selected + 1);
    };
    const totalRecords = reportData?.appointmentSales?.data?.totalCount || 0;
    const PageCount = Math.ceil(totalRecords / rowsPerPage);

    useEffect(() => {
        const payload = {
            dateOfAppointment: formData.dateOfAppointment,
            status: formData.status
        }
        if (formData) {
            dispatch(appointmentSales(formData.search,limits,payload))
        }
    }, [formData,rowsPerPage,mainPage])

    const handleExport = () => {
        const data = {
            dateOfAppointment: formData.dateOfAppointment,
            status: formData.status           
        };
        dispatch(appointmentExcelReports(formData.search, data));
        setIsExporting(true);
    };

    useEffect(() => {
        if (
            isExporting &&
            reportData?.getAppointmentExcelData?.data?.appointments?.length
        ) {
            const exportData = reportData?.getAppointmentExcelData?.data?.appointments.map((item) => ({
                "Date": item.dateOfAppointment ? moment(item.dateOfAppointment).format('DD/MM/YYYY') : '',
                "Time": item.time,
                "First Name": item.firstName,
                "Last Name": item.lastName,
                "Phone Number": item.phoneNumber,
                "Booking Type": item.bookingType,
                "User": item.appointmentBookedBy?.name,            
            }));

            const ws = XLSX.utils.json_to_sheet(exportData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Appointment Report");

            XLSX.writeFile(wb, "Appointment_Report.xlsx");
            setIsExporting(false);
        }
    }, [reportData?.getAppointmentExcelData?.data?.appointments]);

    return (
        <>
            <div className="mt-[100px]">
                <div className="d-flex items-center gap-3">
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Date</label>
                        <input
                            type="date"
                            name="dateOfAppointment"
                            value={formData.dateOfAppointment}
                            onChange={handleFormData}
                            className="w-75 outline-none !border-b"
                        />
                    </div>
                    <div className='w-[200px]'>
                        <label className="text-sm block mb-1">Status</label>
                        <select
                            value={formData.status} name='status' onChange={handleFormData}
                            className="!border-b w-full focus:outline-none"
                        >
                            <option value="">Select Option</option>
                            <option value="confirm">Confirm</option>
                            <option value="pending">Pending</option>
                        </select>
                    </div>
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={formData.search}
                            onChange={handleFormData}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <div className="me-2">
                        <Button
                            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                            onClick={handleExport}  
                        >
                            <BsDownload className="mt-1 me-2" />
                            Download
                        </Button>
                    </div>
                </div>
                <label className='text-end block mt-4 text-gray-600 border-r pe-3'><span> Total Records :</span> <span className='ms-1 text-success border-b border-success'>{reportData?.appointmentSales?.data?.totalCount}</span></label>
            </div>
            <div className="mt-[50px] mb-4">


                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Date</Th>
                                <Th>Time</Th>
                                <Th>Name</Th>
                                <Th>Phone Number</Th>
                                <Th>Doctor Name</Th>
                                <Th>Booking Type</Th>
                                <Th>User</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                reportData?.appointmentSales?.data?.appointments?.length > 0 ? (
                                    reportData?.appointmentSales?.data?.appointments?.map((res) => {
                                        return (
                                            <Tr key={res._id}>
                                                <Td>{res.dateOfAppointment ? moment(res.dateOfAppointment).format('DD/MM/YYYY') : ''}</Td>
                                                <Td>{res.time}</Td>
                                                <Td className='capitalize'>{res.firstName} {" "} {res.lastName}</Td>
                                                <Td>{res.phoneNumber}</Td>
                                                <Td>{res.doctor}</Td>
                                                <Td>{res.bookingType}</Td>
                                                <Td>{res.appointmentBookedBy?.name}</Td>
                                            </Tr>
                                        )
                                    })
                                ) : (
                                    <Tr>
                                        <Td colSpan={6} textAlign={'center'}>No any report</Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />                

        </>
    );
}
